<template>
  <div>
    <h1 class="text-center my-5">
      PRIVATE EQUITY ANALYST (EUROPEAN MARKETS), <span class="text-black-50">LONDON</span>
    </h1>
    <p>
      Actively participate in the early stages of a <b>high-growth data & software start-up focused on Private Capital</b>. A
      unique learning experience, a steppingstone for a career in Private Equity (PE), Operations and Data.
    </p>
    <h4 class="mb-3">The opportunity</h4>
    <p>
      <span class="logo-text">mktBI</span>
      develops <b>data analytics & visualization software for Private Capital professionals</b>. Through a combination of data
      science and business analysis, our interfaces render cherry-picked information for mission-critical activities.
    </p>
    <p>
      Founded in 2019 by a former partner in a large cap PE firm, the company is headed by PE and consulting senior
      executives combining 45 years of experience. We have <b>raised a large Seed Round and agreed the first deployments</b> at
      renowned PE firms. Our investors include partners from leading firms, such as KKR, Vista, Bridgepoint, BC Partners
      and Eurazeo.
    </p>
    <h4 class="mb-3">Your role</h4>
    <p>
      While most of the data originates from systems, the BAs review it, and add vital information through:
    </p>
    <ul>
      <li>Building and maintaining lists of <b>PE targets, deals</b> and <b>precedent transactions</b>;</li>
      <li>Monitoring <b>company news</b> flows;</li>
      <li>Leveraging in-depth <b>knowledge of specific economic sectors</b> (e.g. valuations, key events and players), and of
      <li>specific <b>European markets</b>;</li>
      <li>Compiling lists of <b>private companies</b> in their sectors;</li>
      <li>Maintaining <b>profiles of key investors</b>; PEs, LPs, VCs and family offices.</li>
    </ul>
    <p>
      As we expand, you will have the opportunity to evolve into management, or product development roles.
    </p>
    <h4 class="mb-3">Our commitment to you</h4>
    <ul>
      <li>Base salary, ranging from <b>£ 28,000 to 33,000</b> per annum;</li>
      <li>Discretionary individual <b>performance bonus</b>;</li>
      <li>For strong performers, possibility to benefit from the company’s <b>share option plan</b>;</li>
      <li>Learn the <b>analytics of PE</b> from two former large cap partners;</li>
      <li>Exposure to <b>tech</b> and <b>data science</b>;</li>
      <li>Rewarding and fun <b>co-working environment</b> in vibrant East London (events, sports facilities, etc.).</li>
    </ul>
    <h4 class="mb-3">Your profile</h4>
    <p>
      You hold - or will graduate this year with - a <b>bachelor</b> or <b>master’s degree</b> in business, finance, or related
      fields. You have a keen interest in <b>Finance</b>, and in working with <b>data</b>.
    </p>
    <p>
      You are fluent in <b>English</b>, and able to analyse business and financial content and perform research in at least one
      of <b>the following</b>: German, Dutch, Italian, Spanish, Portuguese, Swedish, Danish, Norwegian.
    </p>
    <p>
      You must be comfortable with:
    </p>
    <ul>
      <li>Analysing <b>financial statements</b>;</li>
      <li>Fundamental <b>M&A concepts</b> such as investment strategies, and valuation methods;</li>
      <li>Collecting and critically <b>assessing vast amounts of information</b>, in a time-boxed environment;</li>
      <li>Organising data in Microsoft <b>Excel</b>.</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "private-equity-analyst-london"
}
</script>


<style scoped lang="scss">

h1 {
  font-size: 50px;
  padding: 50px 0 32px;
  font-weight: 700;

  img {
    height: 50px;
    margin-left: 15px;
  }

  @media(max-width: 640px) {
    font-size: 36px;
    img {
      height: 36px;
    }
  }
}

h4 {
  font-size: 36px;
}

li {
  color: #767f86;
  font-weight: 400;
}

p {
  color: #767f86;
  font-style: normal;
  font-weight: 400;
  @media(max-width: 640px) {
    font-size: 18px;
  }
}
</style>